import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import ObjectForm from "./ObjectForm";

const ObjectDrawer = ({ show, mode, initialValue, onSave, onCancel }) => {
  const [draft, setDraft] = useState(initialValue);
  const [imageLoading, setImageLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setDraft(initialValue);
      setImageLoading(false);
    }
  }, [show, initialValue]);

  const title = mode === "create" ? "Object toevoegen" : "Object bewerken";

  return (
    <Offcanvas
      show={show}
      onHide={onCancel}
      placement="end"
      style={{ width: "min(520px, 100vw)" }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column" style={{ overflow: "hidden" }}>
        {draft && (
          <ObjectForm
            draft={draft}
            onChange={setDraft}
            imageLoading={imageLoading}
            setImageLoading={setImageLoading}
          />
        )}
        <div className="mt-auto pt-3 d-flex justify-content-end gap-2 border-top">
          <button
            type="button"
            onClick={onCancel}
            disabled={imageLoading}
            style={{
              height: 38,
              padding: "0 20px",
              borderRadius: 12,
              border: "1px solid #ccc",
              background: "white",
              color: "#757575",
              fontSize: 15,
              cursor: "pointer",
            }}
          >
            Annuleren
          </button>
          <button
            type="button"
            onClick={() => onSave(draft)}
            disabled={imageLoading || !draft}
            style={{
              height: 38,
              padding: "0 20px",
              borderRadius: 12,
              border: "none",
              background: "#d63230",
              boxShadow: "0px 4px #a22321",
              color: "#fff",
              fontSize: 15,
              cursor: "pointer",
            }}
          >
            Opslaan
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ObjectDrawer;
